/**
 * Usonian CSS > Elements > Form
 */

import { css } from 'styled-components';
import { colors, globals } from 'shared/styles/settings';

export default css`
  input,
  select,
  textarea {
    border-color: ${colors.grayLight2} !important;
    border-radius: ${globals.borderRadiusSmall};
    border-style: solid;
    border-width: 1px;
    box-shadow: none;
    color: ${colors.midnightGrey} !important;
    line-height: 1.25;
    outline: none;
    padding-bottom: 0.5rem;
    padding-left: 0.75rem;
    padding-right: 0.75rem;
    padding-top: 0.5rem;
    transition-duration: 200ms;
    transition-property: background-color, border-color, color;
    transition-timing-function: ease-in-out;
  }

  input[type='number']::-webkit-outer-spin-button,
  input[type='number']::-webkit-inner-spin-button {
    appearance: none;
    margin: 0;
  }

  input:focus,
  select:focus,
  textarea:focus,
  fieldset:focus {
    border-color: ${colors.baseColorAccent};
    box-shadow: none !important;
  }

  input:disabled,
  select:disabled,
  textarea:disabled,
  fieldset:disabled {
    color: ${colors.grayLight};
    cursor: not-allowed;
    opacity: 0.8;
  }

  select {
    background-color: white;
    height: 2.375rem; /* equates to computed input height */
    overflow: visible;
  }

  select[multiple] {
    height: auto;
  }

  input:read-only {
    background-color: rgba(255, 255, 255, 0.5);
    color: ${colors.grayLight};
  }

  input:read-only:focus {
    border-color: ${colors.grayLight};
  }

  /* Prevent Safari from continuing to show placeholder when input !empty */

  input:not([value=''])::placeholder {
    color: rgba(0, 0, 0, 0);
  }

  /* ensure search placeholder still legible */

  input::placeholder,
  input[type='search']::placeholder {
    color: ${colors.grayLight};
  }

  textarea {
    max-width: 100%;
    width: 100%;
  }
`;
